<div
    mat-dialog-content
    class="kh-upload-progress-dialog__content"
>
    <mat-spinner [diameter]="48"></mat-spinner>
    <span class="headline-small kh-upload-progress-dialog__title">{{ data }}</span>
    <p class="body-large kh-upload-progress-dialog__message">{{ progressMessage }}</p>
</div>
<div
    mat-dialog-actions
    class="khts-mat-dialog-actions"
    align="end"
>
    <kh-app-text-button (clicked)="cancelUpload()">{{ cancelUploadLabel }}</kh-app-text-button>
</div>
